import { ADMIN_AUDIT_LOGS_ENDPOINTS, AdminAuditLogsService } from "@/service/api/admin-audit-logs";
import { ListAdminAuditLogsDto } from "@/service/dto/admin-audit-logs";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { toast } from "react-toastify";

const useLogsList = (params?: ListAdminAuditLogsDto) => {
  const query = useQuery({
    queryKey: [ADMIN_AUDIT_LOGS_ENDPOINTS.GET_LOGS, params],
    queryFn: () => AdminAuditLogsService.getLogs(params),
    placeholderData: keepPreviousData,
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      toast.error(query.error?.message || "Erro ao carregar gestoras.");
    }
  }, [query.isError, query.error]);

  return query;
};

export default useLogsList;
